import React from 'react';

/**
 * Tiny "Filtered" badge shown next to a board's stat-card numbers when
 * the current view is restricted by filters or a search term. Without
 * this, the user can mistake a filtered number (e.g. "4 jobs") for the
 * full board total.
 *
 * Renders nothing when `active` is falsy so callers can drop it in
 * unconditionally: `<FilteredPill active={isFiltered} />`.
 */
const FilteredPill = ({ active }) => {
  if (!active) return null;
  return (
    <span
      className="ml-2 align-middle inline-block text-[10px] font-semibold uppercase tracking-wider text-[#B8741A] bg-[#FFF4E1] border border-[#FFE2B0] rounded-full px-2 py-[1px]"
      data-testid="filtered-pill"
      title="These totals reflect the currently filtered view"
    >
      Filtered
    </span>
  );
};

export default FilteredPill;
